module.exports = __webpack_public_path__ + "static/img/roleplay-mr.741376af.png";